// extracted by mini-css-extract-plugin
export default {"avatar":"avatar_avatar__2pM2u"};